<template>
  <div class="Card WineCellar" v-on:click="goTo">
    <h3>{{ $t('virtual-wine-cellar') }}</h3>
  </div>
</template>

<script>
export default {
  name: "WineCellar",
  methods: {
    goTo() {
      this.$emit('openVirtualCellarModal')
    }
  }
}
</script>

<style>
/*WineCellar*/
.Card.WineCellar {
    cursor: pointer;
    background-image: url("../../assets/wine-cellar-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #000;
}

.Card.WineCellar h3 {
    color: #FFF;
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    margin: 0;
    position: relative;
    transition: all 3s ease-in-out;
}

.Card.WineCellar h3::after {
    background-image: url('../../assets/arrow-link-new.svg');
    background-repeat: no-repeat;
    background-position: center;
    content: '';
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 10px;
    height: 20px;
    transition: all .2s ease-in-out;
}

.Card.WineCellar:hover h3::after {
    transform: translateY(-50%) translateX(5px);
}
/*WineCellar END*/
</style>
